// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isNullOrUndefined(value: any): boolean {
  return value === undefined || value === null;
}
export function isNullUndefinedOrEmpty(value: any): boolean {
  return value === undefined || value === null || value === '';
}
